import type {
  AffinityCampaignInfo,
  AffinityParams,
  CallbackParams,
  GetABTestsRequest,
  GetABTestsResponse,
  GetDocsParams,
  GetDocsResponse,
  GetEmailDomainsResponse,
  OCRIstimaraFront,
  OcrIstimaraRequest,
  OcrUploadRequest,
  OcrUploadResponse,
  PushToCRMRequest,
  PushToCRMResponse,
  SaveFormDataRequest,
  SaveFormDataResponse,
  SendEventsRequest,
  SendEventsResponse,
} from './CommonService.types';
import { BaseService, defineApi } from '@/shared/api';

// TODO: should be in app layer
class CommonService extends BaseService {
  async saveFormData(payload: SaveFormDataRequest): Promise<SaveFormDataResponse> {
    return await this.post('/save-form-data', payload);
  }

  async ocrUpload(
    payload: OcrUploadRequest,
    progressHook: (progress: number) => void,
  ): Promise<OcrUploadResponse> {
    const formData = new FormData();
    formData.append('image', payload.image);
    formData.append('type', payload.type);
    return await this.post('/ocr-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
        progressHook(percentCompleted);
      },
    });
  }

  async ocrIstimaraFrontUpload(
    payload: OcrIstimaraRequest,
    progressHook: (progress: number) => void,
  ): Promise<OCRIstimaraFront> {
    const formData = new FormData();
    formData.append('image', payload.image);
    return await this.post('/ocr-istimara-front-side', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
        progressHook(percentCompleted);
      },
    });
  }

  async ocrIstimaraBackUpload(
    payload: OcrIstimaraRequest,
    progressHook: (progress: number) => void,
  ): Promise<OCRIstimaraFront> {
    const formData = new FormData();
    formData.append('image', payload.image);
    return await this.post('/ocr-istimara-back-side', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
        progressHook(percentCompleted);
      },
    });
  }

  async getABTests(payload: GetABTestsRequest): Promise<GetABTestsResponse> {
    return await this.post('/ab-tests', payload);
  }

  async sendEvents(payload: SendEventsRequest): Promise<SendEventsResponse> {
    return await this.post('/events', payload);
  }

  async pushToCRM(payload: PushToCRMRequest): Promise<PushToCRMResponse> {
    return await this.post('/push-to-crm', payload);
  }

  async getDocuments(params: GetDocsParams = {}): Promise<GetDocsResponse> {
    return await this.get('/docs-qatar', { params });
  }

  async getEmailDomains(): Promise<GetEmailDomainsResponse> {
    return await this.get('/email-domains');
  }

  async getAffinityCampaignInfo(params: AffinityParams): Promise<AffinityCampaignInfo> {
    return await this.get('/affinity-campaign-info', { params });
  }

  async getTimeSlots(): Promise<any> {
    return await this.get('/time-slots');
  }

  async requestCallback(params: CallbackParams): Promise<void> {
    return await this.post('/request-callback', params);
  }
}

export const useCommonService = defineApi(CommonService, { version: 'v3' });
